// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"06bb8d63","859":"ef05a3e4"}[chunkId] + ".chunk.js";
};